
import React from "react";
import Layout from "@/components/layout/Layout";
import { SectionHeader } from "@/components/ui/section-header";
import { Helmet } from "react-helmet";

export default function PressPage() {
  return (
    <Layout>
      <Helmet>
        <title>Press | Grandpal</title>
      </Helmet>
      
      <div className="container max-w-4xl py-16">
        <SectionHeader 
          title="Press & Media"
          subtitle="Latest news, press releases and media resources about Grandpal."
          centered
        />
        
        <div className="prose prose-lg max-w-none">
          <h3>Media Contact</h3>
          <p>
            For press inquiries, please contact our media relations team at:
            <br />
            Email: press@grandpal.ie
          </p>
          
          <h3>Press Releases</h3>
          <p>
            Check back soon for our latest press releases and news updates.
          </p>
        </div>
      </div>
    </Layout>
  );
}
